import recruiterService from '@/api/recruiter.service'
import loginService from '@/api/auth.service'

const actions = {
  recruiterInfo(context) {
    const promise = new Promise((resolve, reject) => {
      loginService
        .getRecruiterInfo(context)
        .then(response => {
          context.commit('recrInfo', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  editNameInfo(context, data) {
    const promise = new Promise((resolve, reject) => {
      loginService
        .postEditName(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  editEmailInfo(context, data) {
    const promise = new Promise((resolve, reject) => {
      loginService
        .postRecEditEmail(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  editPasswordInfo(context, data) {
    const promise = new Promise((resolve, reject) => {
      loginService
        .postEditPassword(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  inviteRecTeamMem(context, data) {
    const promise = new Promise((resolve, reject) => {
      loginService
        .inviteRecTeamMem(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  recruiterList(context) {
    const promise = new Promise((resolve, reject) => {
      loginService
        .getRecruiterList(context)
        .then(response => {
          context.commit('recruiterL', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  removeUser(context, data) {
    const promise = new Promise((resolve, reject) => {
      loginService
        .removeRecUser(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  recruiterCompanyList(context) {
    const promise = new Promise((resolve, reject) => {
      loginService
        .recruiterCompanyList(context)
        .then(response => {
          context.commit('recruiterCompL', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  companyUpdate(context, data) {
    const promise = new Promise((resolve, reject) => {
      loginService
        .companyUpdate(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  sendMail(context, data) {
    const promise = new Promise((resolve, reject) => {
      loginService
        .sendMail(context, data)
        .then(response => {
          context.commit('sendMail', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  updateCompanyLogo(context, data) {
    const promise = new Promise((resolve, reject) => {
      loginService
        .updateCompanyLogo(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },

  deleteCompanyLogo(context) {
    const promise = new Promise((resolve, reject) => {
      loginService
        .deleteLogo(context)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  pendingInvitationList(context) {
    const promise = new Promise((resolve, reject) => {
      loginService
        .pendingListApi(context)
        .then(response => {
          context.commit('pendingInvitelist', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  deleteProfilePicture(context, data) {
    const promise = new Promise((resolve, reject) => {
      recruiterService
        .deleteProfilePicture(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  uploadProfilePicture(context, data) {
    const promise = new Promise((resolve, reject) => {
      recruiterService
        .uploadProfilePicture(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  }
}
export default actions
